import React from 'react';
import './ImageGrid.css';

const ImageGrid = ({ title, description, images }) => {
  return (
    <section className="grid-section">
      <div className="grid-content">
        <div className="grid-header">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className="grid-container">
          {images.map((image, index) => (
            <div key={index} className="grid-item">
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGrid; 